import { get, writable } from 'svelte/store';

import iconSettings from '../lib/shared/Icons/svg/official/settings_FILL0_wght400_GRAD0_opsz24.svg';
import iconImports from '../lib/shared/Icons/svg/official/Icon fa-solid-file-import.svg';
import iconExports from '../lib/shared/Icons/svg/official/Icon fa-solid-file-export.svg';
import iconJobs from '../lib/shared/Icons/svg/official/Zlecenia.svg';
import iconToolsPowerDrill from '../lib/shared/Icons/svg/tools_power_drill_FILL0_wght400_GRAD0_opsz24.svg';
import iconVehicle from '../lib/shared/Icons/svg/official/Pojazdy.svg';
import iconAccounts from '../lib/shared/Icons/svg/person_FILL0_wght400_GRAD0_opsz24_black.svg';
import PageSettings from '../lib/components/Settings/PageSettings.svelte';
import PageUploadFile from '../lib/components/Import/PageUploadFile.svelte';
import PageAssignColumns1141 from '../lib/components/ColumnSelectPro/PageAssignColumns.svelte';
import PageImports from '../lib/components/Import/PageImports.svelte';
import type { LocationResponseType } from '../lib/components/Location/types';
import type { TacticalPlanRule } from '../lib/components/_deprecated_components/TacticalPlan/TacticalPlanRule';
import PageWorkshop from '../lib/components/Workshop/PageWorkshop.svelte';
import { createCurrentZoneListStore } from '../lib/components/_deprecated_components/TacticalPlan/CurrentZoneListStore';
import PageGeocoding from '../lib/components/Import/PageGeocoding.svelte';
import PageManualAddJob from '../lib/components/Location/PageManualAddJob.svelte';
import { type QueriesType } from '../lib/components/telematics/types';
import { MenuContextFactory } from '../lib/components/MenuDropdown/MenuContext/MenuContextFactory';
import PageAdmin from '../lib/components/Admin/PageAdmin.svelte';
import PageUserPermissions from '../lib/components/UserPermissions/PageUserPermissions.svelte';
import iconUserPermissions from '../lib/shared/Icons/svg/group_FILL0_wght400_GRAD0_opsz24.svg';
import { app } from './app';
import PageJobs from '../lib/components/Location/PageJobs.svelte';
import PageConnection from '../lib/components/Connection/PageConnection.svelte';
import iconRoute from '../lib/shared/Icons/svg/route.svg';
import type { RouteResponseType } from '../lib/components/Connection/Routes/RoutesApi';
import PageExports from '../lib/components/Export/PageExports.svelte';
import PageManualAddConnection from '../lib/components/Connection/PageManualAddConnection.svelte';
import PageRouteType from '../lib/components/RouteType/PageRouteType.svelte';
import PageImportAnalyze from '../lib/components/Import/PageImportAnalyze.svelte';

export const defaultPageLink = '/';

// export const showUnassignedDeliveries = writable(false);

// debug only when host is in localhost
export const debug = writable(false);
export const featureTogglerVisible = writable(false);

export const accountName = writable<string>('...');
export let tacticalPlanName = writable<string>('');
export let tacticalPlanRuleCurrent = writable<string | null>(null);

export const currentZoneList = createCurrentZoneListStore();

export let lastClickedPosition = writable<{ x: number; y: number }>({ x: 0, y: 0 });
lastClickedPosition.subscribe(value => {
    // console.log('lastClickedPosition', value);
    MenuContextFactory.setCoords(value.x, value.y);
});

export let disableRefreshing = writable<boolean>(false);

export type TacticalPlanStoreType = {
    triggerStartSaveThisRuleByInnerId: string;
    saveResult: {
        success: boolean;
        message: string;
    };
    triggerZonesSave: boolean;
    countedErrors: number;
    ruleToCopy: TacticalPlanRule | null;
};

export let tacticalPlanStore = writable<TacticalPlanStoreType>({
    triggerStartSaveThisRuleByInnerId: '',
    saveResult: {
        success: false,
        message: '',
    },
    triggerZonesSave: false,
    countedErrors: 0,
    ruleToCopy: null,
});

//
// // change debug value to true if host is localhost
// if (window.location.hostname === 'localhost') {
//     debug.set(true);
// }

// change debug value on Ctrl+1
document.addEventListener('keydown', event => {
    if (event.ctrlKey && event.shiftKey && event.altKey && event.key === 'F1') {
        debug.set(!get(debug));
        console.log('Ctrl+1', get(debug));
    }
    if (event.ctrlKey && event.shiftKey && event.altKey && event.key === 'F2') {
        featureTogglerVisible.set(!get(featureTogglerVisible));
        console.log('Ctrl+0', get(featureTogglerVisible));
    }
});

export const mainMenu = writable({
    currentPage: 'PageUploadFile',
    expanded: localStorage.getItem('mainMenuExpanded') === 'true',
    fullscreenMode: false,
    items: [
        // {
        //     id: 'PageStart',
        //     component: PageStart,
        //     to: '/start',
        //     icon: iconFlag,
        //     label: 'Start',
        //     visible: true,
        //     visibleInMenu: true,
        //     side: 'left',
        // },
        {
            id: 'PageJobs',
            component: PageJobs,
            to: '/',
            icon: iconJobs,
            label: 'Jobs',
            visible: true,
            visibleInMenu: true,
            side: 'left',
            notification: {
                reload: true,
            },
        },
        {
            id: 'PageConnection',
            component: PageConnection,
            to: '/connections',
            icon: iconRoute,
            label: 'Routes',
            visible: true,
            visibleInMenu: true,
            side: 'left',
            notification: {
                reload: true,
            },
        },
        {
            id: 'PageUploadFile',
            component: PageUploadFile,
            to: '/upload-file',
            icon: iconImports,
            label: 'Upload file',
            visible: true,
            visibleInMenu: false,
            side: 'left',
        },
        {
            id: 'PageGeocoding',
            component: PageGeocoding,
            to: '/geocoding',
            icon: '',
            label: '',
            visible: false,
            visibleInMenu: false,
            side: 'left',
        },
        {
            id: 'PageManualAddJob',
            component: PageManualAddJob,
            to: '/manual-add-job',
            icon: '',
            label: '',
            visible: false,
            visibleInMenu: false,
            side: 'left',
        },
        {
            id: 'PageManualAddConnection',
            component: PageManualAddConnection,
            to: '/manual-add-connection',
            icon: '',
            label: '',
            visible: false,
            visibleInMenu: false,
            side: 'left',
        },
        {
            id: 'PageAssignColumns',
            component: PageAssignColumns1141,
            to: '/assign-columns',
            icon: '',
            label: 'Assign columns',
            visible: true,
            visibleInMenu: false,
            side: 'both',
        },
        {
            id: 'PageImportAnalyze',
            component: PageImportAnalyze,
            to: '/import-analyze',
            icon: '',
            label: 'Import analyze',
            visible: true,
            visibleInMenu: false,
            side: 'both',
        },
        {
            id: 'PageImports',
            component: PageImports,
            to: '/imports',
            icon: iconImports,
            label: 'Imports',
            visible: true,
            visibleInMenu: true,
            side: 'left',
        },
        {
            id: 'PageExports',
            component: PageExports,
            to: '/exports',
            icon: iconExports,
            label: 'Export',
            visible: true,
            visibleInMenu: true,
            side: 'left',
        },
        // {
        //     id: 'PageDashboard',
        //     component: PageDashboard,
        //     to: '/dashboard',
        //     icon: iconDashboardCustomize,
        //     label: 'Dashboard',
        //     visible: true,
        //     visibleInMenu: true,
        //     side: 'right',
        // },
        {
            id: 'PageSettings',
            component: PageSettings,
            to: '/settings',
            icon: iconSettings,
            label: 'Settings',
            visible: true,
            visibleInMenu: true,
            side: 'right',
        },
        {
            id: 'PageRouteType',
            component: PageRouteType,
            to: '/route-type',
            icon: iconVehicle,
            label: 'Route types',
            visible: true,
            visibleInMenu: true,
            side: 'right',
        },
        {
            id: 'PageWorkshop',
            component: PageWorkshop,
            to: '/workshop',
            icon: iconToolsPowerDrill,
            label: '# WORKSHOP #',
            visible: false,
            visibleInMenu: false,
            side: 'right',
        },
        {
            // odsłaniane w MainMenuVertical.svelte tylko dla admina
            id: 'PageAdmin',
            component: PageAdmin,
            to: '/admin',
            icon: iconAccounts,
            label: 'Administration',
            visible: false,
            visibleInMenu: false,
            side: 'right',
        },
        {
            // odsłaniane w MainMenuVertical.svelte tylko dla roli user_manager
            id: 'PageUserPermissions',
            component: PageUserPermissions,
            to: '/user-permissions',
            icon: iconUserPermissions,
            label: 'User permissions',
            visible: false,
            visibleInMenu: false,
            side: 'right',
        },
    ],
    autoShowNotification: true
});

mainMenu.subscribe(value => {
    localStorage.setItem('mainMenuExpanded', value.expanded ? 'true' : 'false');
});

export const pagesAvailableInPlanningMode = [
    // 'Home',
    'PageStart',
    'PagePlanning',
    'PageZones',
    // 'PageMaps',
    'PageUploadFile',
    'PageAssignColumns',
    'PageOrdersToBeCompleted',
    'ZoneList',
    'PageVehicles',
    'PageWarehouses',
    'PageSettings',
];

export const pagesAvailableNotInPlanningMode = ['PageVehicles', 'WarehouseList', 'ZoneList', 'PageSettings'];

export const onMapLoaded = writable(false);
export const isMapLoaded = writable(false);

export const simpleView = writable(true);

export type PlanningType = {
    adHocMode: boolean;
    adHocModeEnabled: boolean;
    setRouteEnableTime: boolean;
    selectedRouteEnableDate: string;
    selectedRouteEnableTime: string;
    currentScenarioId: number | null;
    planningStarted: boolean;
    assignments: number;
    selectedDay: string;
    routingProgress: number | null;
    forceReload: boolean;
    selectedAssignments: number[];
    quickCategoryHideMethod: 'hide' | 'opacity';
    forceToSetTacticalPlan: boolean;
};

export const planning = writable<PlanningType>({
    adHocMode: false,
    adHocModeEnabled: false,
    setRouteEnableTime: true,
    selectedRouteEnableDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60 * 1000).toISOString().substring(0, 10),
    selectedRouteEnableTime: '20:00',
    currentScenarioId: null,
    planningStarted: false,
    assignments: 0,
    selectedDay: new Date(Date.now() - new Date().getTimezoneOffset() * 60 * 1000).toISOString().substring(0, 10),
    routingProgress: null,
    forceReload: false,
    selectedAssignments: [],
    quickCategoryHideMethod: 'opacity',
    forceToSetTacticalPlan: false,
});

export type DeliverListType = {
    selectMode: 'filtered' | 'selected';
    selectedOrUnselected: number[];
    query: QueriesType;
    queryFilter: QueriesType;
    currentAssignment: null;
    countFiltered: { count: number };
    countAssignedFiltered: { count: number };
    countSuggestedFiltered: { count: number };
    triggerReload: boolean;
    displayedAssignmentJobDetails: {
        jobId: number;
        hasAssignment: boolean;
        hasSuggestion: boolean;
        hasAdhoc: boolean;
        canBeRejected: boolean;
        canBeAssigned: boolean;
    }[];
    allJobIds: number[];
    isRouteVariantVisible: boolean;
    filterHidden: boolean;
    expandedIndex: number[]; // jobId[]
};

export const deliveryList = writable<DeliverListType>({
    selectMode: 'selected',
    selectedOrUnselected: [],
    query: {},
    queryFilter: {},
    currentAssignment: null,
    countFiltered: { count: 0 },
    countAssignedFiltered: { count: 0 },
    countSuggestedFiltered: { count: 0 },
    triggerReload: false,
    displayedAssignmentJobDetails: [],
    allJobIds: [],
    isRouteVariantVisible: false,
    filterHidden: false,
    expandedIndex: [], // jobId
});

/*
{
  "x": 20.933074951171875,
  "y": 52.40283780245278,
  "quality": 0,
  "countryCodes": {
    "iso2": "PL",
    "iso3": "POL",
    "targeo": "PL"
  },
  "country": "PL",
  "province": "mazowieckie",
  "district": "legionowski",
  "community": "Legionowo",
  "city": "Legionowo",
  "quarter": "",
  "postcode": "",
  "street": "Sienkiewicza Henryka",
  "house": "33",
  "mapLink": "https://mapa.targeo.pl/20.933074951172,52.402837802453,23"
}
 */

export type RevGeoDetailsType = {
    x: number;
    y: number;
    quality: number;
    countryCodes: {
        iso2: string;
        iso3: string;
        targeo: string;
    };
    country: string;
    province: string;
    district: string;
    community: string;
    city: string;
    quarter: string;
    postcode: string;
    street: string;
    house: string;
    mapLink: string;
};

export type JobType = {
    selectedOrUnselected: number[];
    // selectAllChecked: boolean,
    selectMode: 'filtered' | 'selected';
    filteredJobs: LocationResponseType[];
    defaultTargetDate: string;
    countFiltered: { count: number };
    countTotal: { count: number };
    forceRecount: boolean;
    forceReload: boolean;
    forceReloadFilter: boolean;
    revGeoDetails: RevGeoDetailsType | null;
    showHistory: boolean;
};

export const jobs = writable<JobType>({
    selectedOrUnselected: [],
    selectMode: 'selected',
    filteredJobs: [],
    countFiltered: { count: 0 },
    countTotal: { count: 0 },
    defaultTargetDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60 * 1000 + 1000 * 60 * 60 * 24)
        .toISOString()
        .substring(0, 10), // TODO: DEPRECATED
    forceRecount: false,
    forceReload: false,
    forceReloadFilter: false,
    revGeoDetails: null,
    showHistory: false,
});

export type RouteType = {
    selectedOrUnselected: number[];
    selectMode: 'filtered' | 'selected';
    filteredJobs: RouteResponseType[];
    countFiltered: { count: number };
    countTotal: { count: number };
    forceRecount: boolean;
    forceReload: boolean;
    forceReloadFilter: boolean;
    revGeoDetails: RevGeoDetailsType | null;
    showHistory: boolean;
    currentTransactionCount: { count: number };
};

export const routes = writable<RouteType>({
    selectedOrUnselected: [],
    selectMode: 'selected',
    filteredJobs: [],
    countFiltered: { count: 0 },
    countTotal: { count: 0 },
    forceRecount: false,
    forceReloadFilter: false,
    forceReload: false,
    revGeoDetails: null,
    showHistory: false,
    currentTransactionCount: { count: 0 },
});
